{
  "reportingConfiguration": {
    "title": "Berichtsparametrierung",
    "information": "In regelmäßigen Abständen wird ein Bericht an die unten konfigurierten Kontakte gesendet.",
    "frequency": "Berichtshäufigkeit (in Tagen)",
    "time": "Berichtszeit"
  },
  "recipients": {
    "title": "Empfänger",
    "users": {
      "empty": "Keine Empfänger",
      "select": {
        "label": "Empfänger hinzufügen"
      },
      "add": {
        "label": "Empfänger hinzufügen",
        "notification": {
          "success": "Die folgenden Empfänger wurden hinzugefügt"
        }
      },
      "remove": {
        "label": "Die ausgewählten Empfänger entfernen",
        "confirm": {
          "title": "Empfänger entfernen",
          "message": "Die folgenden Empfänger werden entfernt:"
        },
        "notification": {
          "success": "Die folgenden Empfänger wurden entfernt"
        }
      }
    }
  },
  "validation": {
    "frequency": {
      "required": "Die Berichtshäufigkeit ist erforderlich"
    },
    "time": {
      "required": "Die Berichtszeit ist erforderlich"
    }
  }
}
